import { InputFieldDef } from '../../../types/admin';

const sideOf = (field: InputFieldDef) => field.direction ?? 'in';
const identityOf = (field: InputFieldDef) => `${sideOf(field)}:${field.key ?? field.name}`;

/**
 * Adds imported fields to the current list. A field that already exists (same side + key) is
 * replaced by the imported definition but keeps what the schema cannot express and the admin set
 * by hand: semantic, pricingDimension, statusMap, uiGroup.
 */
export function mergeImportedFields(
  current: InputFieldDef[],
  imported: InputFieldDef[]
): InputFieldDef[] {
  const existing = new Map(current.map((field) => [identityOf(field), field]));
  const importedIds = new Set(imported.map(identityOf));

  const merged = imported.map((field) => {
    const previous = existing.get(identityOf(field));
    if (!previous) return field;
    return {
      ...field,
      semantic: previous.semantic,
      pricingDimension: previous.pricingDimension,
      statusMap: previous.statusMap,
      uiGroup: previous.uiGroup,
    };
  });

  return [...current.filter((field) => !importedIds.has(identityOf(field))), ...merged];
}
